import React from 'react';

const RotatingLogo = ({ size = 64, className = '' }) => {
  return (
    <div className={`animate-spin ${className}`} style={{ width: size, height: size }}>
      <svg 
        width={size} 
        height={size} 
        viewBox="0 0 512 512" 
        fill="none" 
        xmlns="http://www.w3.org/2000/svg"
      >
        {/* Main outer octagon shape */}
        <path 
          d="M 120 80 L 280 80 L 320 120 L 320 280 L 280 320 L 120 320 L 80 280 L 80 120 Z" 
          fill="none" 
          stroke="#00d68f" 
          strokeWidth="16" 
          strokeLinejoin="round"
        />
        
        {/* Inner square */}
        <rect 
          x="160" 
          y="120" 
          width="80" 
          height="80" 
          fill="none" 
          stroke="#00d68f" 
          strokeWidth="12"
        />
        
        {/* Base rectangle - removed as requested */}
        {/* <rect x="200" y="360" width="80" height="32" fill="#00d68f"/> */}
      </svg>
    </div>
  );
};

export default RotatingLogo; 